import { render } from "./GenericToolResultSurface.vue?vue&type=template&id=03270656"
import script from "./GenericToolResultSurface.vue?vue&type=script&lang=js"
export * from "./GenericToolResultSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__